<script setup lang="ts">
    import { ICON_CONFIG } from '@/config.components';
    // eslint-disable-next-line no-restricted-imports
    import * as iconsSolid from '@heroicons/vue/24/solid';
    // eslint-disable-next-line no-restricted-imports
    import * as iconsOutlined from '@heroicons/vue/24/outline';
    import { computed } from 'vue';

    type TIconName = keyof typeof iconsOutlined;

    const {
        name,
        size = 'md',
        type = 'solid',
    } = defineProps<{
        name: TIconName;
        size?: keyof typeof ICON_CONFIG.size;
        type?: 'outlined' | 'solid';
    }>();

    const iconsLib = computed(() => (type === 'solid' ? iconsSolid : iconsOutlined));

    const iconComponent = computed(() => iconsLib.value[name]);
</script>

<template>
    <component
        :is="iconComponent"
        :class="ICON_CONFIG.size[size]"
        v-bind="$attrs"
    />
</template>
